<template>
  <b-form-group :label-for="inputId">
    <template #label>
      <span v-if="question">
        {{ question }} <span class="text-danger">*</span>
      </span>
      <span
        v-else
        class="text-muted"
      >
        Loading question...
      </span>
    </template>
    <div class="d-flex align-items-center">
      <b-form-input
        :id="inputId"
        :value="captchaAnswer"
        type="number"
        required
        inputmode="numeric"
        :disabled="loading"
        @input="$emit('update:captchaAnswer', $event)"
      />
      <b-button
        type="button"
        variant="outline-secondary"
        class="ml-1 flex-shrink-0"
        :disabled="loading"
        @click="refresh"
      >
        Refresh
      </b-button>
    </div>
  </b-form-group>
</template>

<script>
import axios from '@/libs/axios'
import { BButton, BFormGroup, BFormInput } from 'bootstrap-vue'
import { sweetError } from '@/libs/sweet-alerts'

export default {
  name: 'MathCaptchaField',
  components: {
    BButton,
    BFormGroup,
    BFormInput,
  },
  props: {
    inputId: {
      type: String,
      required: true,
    },
    captchaToken: {
      type: String,
      default: '',
    },
    captchaAnswer: {
      type: [String, Number],
      default: '',
    },
    endpoint: {
      type: String,
      default: 'api/captcha',
    },
  },
  emits: ['update:captchaToken', 'update:captchaAnswer'],
  data() {
    return {
      loading: false,
      question: '',
    }
  },
  mounted() {
    this.refresh()
  },
  methods: {
    async refresh() {
      this.loading = true
      this.$emit('update:captchaAnswer', '')
      try {
        const { data } = await axios.get(this.endpoint)
        this.$emit('update:captchaToken', data.token || '')
        this.question = data.question || ''
      } catch (e) {
        this.$emit('update:captchaToken', '')
        this.question = ''
        sweetError('Error', 'Could not load the question. Please try again.')
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
